/* ──────────────────────────────────────────────────────────────────────────
   report.js — فراخوانی گزارش‌های شاسی backend/reporting از هر صفحه.

   سند چاپی را از سرور می‌گیرد و در یک پنجرهٔ تازه باز می‌کند؛
   چاپ و «ذخیره به PDF» با Ctrl+P همان پنجره انجام می‌شود.

   چرا fetch و نه window.open مستقیم؟ چون آدرس گزارش با توکن Bearer محافظت
   می‌شود و بازکردن مستقیم یک تب، هدر Authorization را نمی‌فرستد.

   استفاده:
     import { openReport, downloadReport, reportList } from '../../components/report';

     openReport('accounting.document_print', { document_id: 12, detail1: 1 });
     openReport('accounting.document_list', { year, by:'date', from, to }, 'pdf');
     downloadReport('accounting.document_list', { ... });          // اکسل
   ────────────────────────────────────────────────────────────────────────── */

const BASE = '/api/reports';

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });

function qs(params) {
  const p = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    p.append(k, typeof v === 'boolean' ? (v ? '1' : '0') : String(v));
  });
  return p.toString();
}

async function errMsg(res) {
  try {
    const j = await res.json();
    return j.msg || 'خطا در تهیه گزارش';
  } catch (e) {
    return 'خطا در تهیه گزارش';
  }
}

/** فهرست گزارش‌های قابل دسترس کاربر. */
export async function reportList() {
  const res = await fetch(`${BASE}/`, { headers: auth() });
  if (!res.ok) throw new Error(await errMsg(res));
  return res.json();
}

/** دادهٔ خام گزارش (برای پیش‌نمایش در خود صفحه). */
export async function reportJson(key, params) {
  const res = await fetch(`${BASE}/${key}/?format=json&${qs(params)}`, { headers: auth() });
  if (!res.ok) throw new Error(await errMsg(res));
  return res.json();
}

/**
 * نمایش سند چاپی در پنجرهٔ تازه.
 * format: 'html' (پیش‌فرض، آمادهٔ Ctrl+P) یا 'pdf' (اگر موتور PDF روی سرور نصب باشد).
 */
export async function openReport(key, params, format = 'html') {
  const res = await fetch(`${BASE}/${key}/?format=${format}&${qs(params)}`, { headers: auth() });
  if (!res.ok) throw new Error(await errMsg(res));
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const w = window.open(url, '_blank');
  if (!w) {
    // مسدودشدن پاپ‌آپ: به‌جای پنجره، فایل دانلود می‌شود
    const a = document.createElement('a');
    a.href = url;
    a.download = `${key}.${format === 'pdf' ? 'pdf' : 'html'}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return true;
}

/** خروجی اکسل همان گزارش. */
export async function downloadReport(key, params, filename) {
  const res = await fetch(`${BASE}/${key}/?format=xlsx&${qs(params)}`, { headers: auth() });
  if (!res.ok) throw new Error(await errMsg(res));
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename || `${key}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 60000);
  return true;
}

/** امضاکنندگان یک گزارش (tblReportParaf) — برای بررسی تنظیمات پاراف. */
export async function reportSigners(key, params) {
  const res = await fetch(`${BASE}/${key}/signers/?${qs(params)}`, { headers: auth() });
  if (!res.ok) throw new Error(await errMsg(res));
  return res.json();
}
